import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id 59803983-F6CE-4D40-B83C-36D42C9464A9
 * name circle
 * version: 1.9.32
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/circle.svg
 * tags
 * - Shape 
 */
export const CircleIcon = createSvgIcon(<><path d="M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" /></>, 'CircleIcon');
export default CircleIcon